// components
import Spinner from '../spinner/spinner'

// styles
import styles from './step-card-loader.module.scss'

const StepCardLoader = (): JSX.Element => {
	return (
		<div className={styles.stepCardLoader}>
			<Spinner />
		</div>
	)
}

export default StepCardLoader
